export const FIND_ORDER_PRODUCTS_BY_IDS = 'OVID/V3/FIND_ORDER_PRODUCTS_BY_IDS_START'
export const FIND_ORDER_PRODUCTS_BY_IDS_SUCCESS = 'OVID/V3/FIND_ORDER_PRODUCTS_BY_IDS_SUCCESS'
export const FIND_ORDER_PRODUCTS_BY_IDS_FAILED = 'OVID/V3/FIND_ORDER_PRODUCTS_BY_IDS_FAILED'
